import { useCallback, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { SPProvide } from 'src/entities/subscription/model';
import { ICatalogItemState, catalogItemSlice } from 'src/entities/catalog';
import { useCatalogItemProtection } from './useCatalogItemProtection';

export const useOpenCatalogItem = (provide?: SPProvide) => {
  const dispatch = useDispatch();
  const catalogItemRef = useRef<ICatalogItemState | null | undefined>(null);
  const openCatalogItem = useCatalogItemProtection({
    provide,
    events: {
      onAuthSuccess() {
        if (catalogItemRef.current) {
          dispatch(catalogItemSlice.actions.setCatalogItem(catalogItemRef.current));
        }
      },
    },
  });

  return useCallback(
    (catalogItem: ICatalogItemState) => {
      catalogItemRef.current = catalogItem;
      if (openCatalogItem(catalogItem).isOk) {
        dispatch(catalogItemSlice.actions.setCatalogItem(catalogItem));
      }
    },
    [openCatalogItem, dispatch],
  );
};
